/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'
import { parse } from 'query-string'

import Feature from '@modules/utils/feature'
import { getBearerToken } from '@modules/auth/auth'
import withRouter from '@modules/routing/withRouter'

import { getAuthMethods } from '@/reducers/authMethods'
import { getLoginRequest, fetchAuthMethodsRequest } from '@/reducers/asyncRequests/registry'

import { redirectAfterLogin, fetchAuthMethods, loginAndRedirect } from '../../../../../actions/auth'
import { isFeatureActivated } from '../../../../../selectors'

import BasicLogin from './BasicLogin'

import type { ConsumerProps, DispatchProps, StateProps } from './types'
import type { ReduxState, ThunkDispatch } from '@/types/redux'

const mapStateToProps = (
  state: ReduxState,
  { router: { location } }: ConsumerProps,
): StateProps => {
  const { hash } = location
  const { redirectTo } = parse(location.search.slice(1))
  const basicAuthProxyPassEnabled = isFeatureActivated(state, Feature.basicAuthProxyPass)
  const newBearerToken = basicAuthProxyPassEnabled ? getBearerToken(hash) : null

  return {
    redirectTo: typeof redirectTo === `string` ? redirectTo : undefined,
    newBearerToken,
    loginRequest: getLoginRequest(state),
    authMethods: getAuthMethods(state),
    fetchAuthMethodsRequest: fetchAuthMethodsRequest(state),
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  loginAndRedirect: (args) => dispatch(loginAndRedirect(args)),
  redirectAfterLogin: (args) => redirectAfterLogin(args),
  fetchAuthMethods: () => dispatch(fetchAuthMethods()),
})

export default withRouter(
  connect<StateProps, DispatchProps, ConsumerProps>(
    mapStateToProps,
    mapDispatchToProps,
  )(BasicLogin),
)
